export const FOUR_WAY_SELECTED_GENES_ROWS = 10;
export const VOLCANO_SELECTED_GENES_PAGE_ROWS = 13;
